import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const MAHero = () => {
  return (
    <section id="ma-advisory" className="relative min-h-[90vh] flex items-center overflow-hidden bg-brand-black py-24">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop')] opacity-20 grayscale bg-cover bg-center"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-brand-black via-transparent to-brand-black"></div>
        <motion.div 
          animate={{ opacity: [0.1, 0.3, 0.1], scale: [1, 1.1, 1] }}
          transition={{ duration: 10, repeat: Infinity }}
          className="absolute top-1/4 -right-1/4 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-[120px]"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold text-white text-xs font-bold tracking-[0.2em] uppercase rounded-sm mb-8 shadow-lg shadow-brand-gold/20">
              Premium Service Division
            </div>
            <h1 className="text-5xl md:text-7xl font-bold tracking-tighter leading-[0.95] mb-8 text-white">
              Mergers & <br /> Acquisitions <br /> 
              <span className="text-brand-gold">Advisory</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-400 font-light max-w-xl mb-12 leading-relaxed">
              Strategic transaction advisory designed to unlock long-term enterprise value through institutional-grade execution.
            </p>
            <div className="flex flex-wrap gap-6">
              <a href="mailto:admin@whiteknightgc.com" className="px-10 py-5 bg-brand-gold text-white font-bold tracking-wide hover:bg-white hover:text-brand-black transition-all duration-500 shadow-xl shadow-brand-gold/10 inline-block text-center">
                Schedule Consultation
              </a>
              <a href="#about" className="px-10 py-5 border border-white/20 text-white font-bold tracking-wide hover:bg-white/10 transition-all duration-500 backdrop-blur-sm inline-block text-center">
                Explore Process
              </a>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="hidden lg:block relative"
          >
            {/* Abstract Financial Graphic Representation */}
            <div className="relative w-full aspect-square border border-white/5 rounded-full p-12">
              <div className="absolute inset-0 bg-brand-gold/5 rounded-full animate-pulse"></div>
              <div className="relative h-full w-full border border-brand-gold/20 rounded-full flex items-center justify-center">
                <div className="text-center">
                  <div className="text-6xl text-brand-gold font-light mb-2">♞</div>
                  <div className="text-xs tracking-[0.4em] uppercase text-gray-500">Global Strategy</div>
                </div>
                {/* Orbiting nodes */}
                {[0, 72, 144, 216, 288].map((deg, i) => (
                  <motion.div 
                    key={i}
                    animate={{ rotate: 360 }}
                    transition={{ duration: 20 + i * 2, repeat: Infinity, ease: "linear" }}
                    className="absolute w-full h-full"
                    style={{ rotate: deg }}
                  >
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3 h-3 bg-brand-gold rounded-full shadow-[0_0_15px_rgba(182,141,64,0.8)]"></div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MAHero;